var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"fluid":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('h4',[_vm._v("Serviços - Nfse")]),_c('v-spacer')],1),_c('CardSearchNfse',{attrs:{"process-ref":_vm.processRef}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }